<template>
  <div>
    <bar-chart class="charts__chart" :chart-data="chartData" :style="chartHeight" />
    <div class="list-view list-view--compact">
      <div class="list-view__header">
      <div>Answer Choices</div>
      <div>Responses</div>
      </div>
      <div class="list-view__row" v-for="(option, index) in field.values">
      <div class="text-center">{{ option.title }}</div>
      <div>{{ option.percentage }}% ({{ option.numberOfResponses }})</div>
      </div>
    </div>
  </div>
</template>

<script>
import BarChart from '../charts/BarChart';

export default {
  name: 'analysis-multiple-response',

  props: ['field', 'numberOfResponses'],

  components: { BarChart },

  computed: {
    chartData() {
      const fieldValues = this.field.values.filter(option => option.percentage !== 0);

      return {
        labels: fieldValues.map(option => option.title),
        datasets: [{
          numberOfResponses: this.numberOfResponses,
          backgroundColor: '#B61311',
          data: [...fieldValues.map(option => option.percentage)],
        }],
      };
    },

    chartHeight() {
      let height = Math.ceil(this.field.values.filter(option => option.percentage !== 0).length / 2) * 10;
      height = Math.min(height, 100);
      return `height: ${Math.max(height, 15)}0px;`;
    },
  },
};
</script>